module.exports = __webpack_public_path__ + "static/img/首页007.4b25017.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/dingding/首页007.png
// module id = tEAr
// module chunks = 94